import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import socket from "../../../Socket";
import storage from "../../../Storage";
import {
  decode,
  encode,
  getElement,
  sendNotfication,
  isEmail,
  Event,
  DEVELOPMENT,
  wait,
  randomString,
} from "../../../Helper";
import C from "../../../Constant";
import axios from "axios";

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 900px;
    margin: 20px auto;

    @media (max-width: 768px) {
      max-width: 100%;
      margin: 0;
      height: 100vh;
      display: flex;
      align-items: stretch;
    }

    @media (max-width: 480px) {
      max-width: 100%;
      margin: 0;
      height: 100vh;
    }
  }

  .modal-content {
    background-color: #232626;
    color: white;
    border-radius: 12px;
    border: none;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
      border-radius: 0;
      height: 100vh;
      padding: 40px;
      max-height: 100vh;
    }

    @media (max-width: 700px) {
      border-radius: 0;
      height: 100vh;
      padding: 0px;
      max-height: 100vh;
    }
  }
`;

const RegisterContainer = styled.div`
  display: flex;
  min-height: 500px;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
    height: 100vh;
  }
`;

const RegisterLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    flex: 0 0 auto;
  }

  @media (max-width: 480px) {
    min-height: 30vh;
  }
`;

const RegisterTopImage = styled.img`
  max-width: 100%;
  height: auto;

  @media (max-width: 768px) {
    width: 100%;
    object-fit: cover;
    max-height: 300px;
  }

  @media (max-width: 480px) {
    width: 100%;
    object-fit: cover;
    max-height: 300px;
  }
`;

const RegisterLogoImage = styled.img`
  max-width: 150px;
  height: auto;

  @media (max-width: 768px) {
    max-width: 120px;
  }

  @media (max-width: 480px) {
    max-width: 100px;
  }
`;

const MobileCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    display: flex;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const RegisterRight = styled.div`
  flex: 1;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 30px 25px;
    flex: 1;
    min-height: 65vh;
    overflow-y: auto;
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
    min-height: 70vh;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`;

const SignUpTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: white;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  // @media (max-width: 768px) {
  //   display: none;
  // }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputLabel = styled.label`
  color: #9ca3af;
  font-size: 14px;
  font-weight: 500;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  background-color: #1e2121;
  border: 2px solid #3a4142;
  border-radius: 8px;
  color: white;
  padding: 8px 16px;
  font-size: 16px;
  transition: all 0.3s ease;

  &::placeholder {
    color: #6b7280;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #ffa500;
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
    background-color: #252828;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 16px;
  }
`;

const PhoneInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledPhoneInput = styled.input`
  width: 100%;
  background-color: #1e2121;
  border: 2px solid #3a4142;
  border-radius: 8px;
  color: white;
  padding: 8px 16px;
  padding-right: 120px;
  font-size: 16px;
  transition: all 0.3s ease;

  &::placeholder {
    color: #6b7280;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #ffa500;
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
    background-color: #252828;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
    padding-right: 110px;
    font-size: 16px;
  }
`;

const SendOtpButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  color: #000;
  border-radius: 6px;
  cursor: pointer;
  background: linear-gradient(90deg, #ffd700, #ff8c00);
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-50%) translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 140, 0, 0.4);
  }

  @media (max-width: 480px) {
    height: 28px;
    padding: 0 8px;
    font-size: 11px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 10px;
`;

const SignUpButton = styled.button`
  width: 100%;
  background: linear-gradient(90deg, #ffd700, #ff8c00);
  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.3);
  border: none;
  border-radius: 8px;
  color: #000;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 140, 0, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px;
    font-size: 15px;
  }
`;

const SignInSection = styled.div`
  text-align: center;
  // margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #3a4142;
  color: #9ca3af;
  font-size: 14px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
    padding: 20px 0px;
  }
`;

const SignInButton = styled.button`
  background: none;
  border: none;
  color: #ffa500;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-left: 5px;

  &:hover {
    color: #ffb347;
    text-decoration: underline;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  // margin: 5px 0;
`;

const CheckboxInput = styled.input`
  margin: 0;
  margin-top: 2px;
  flex-shrink: 0;
`;

const CheckboxLabel = styled.label`
  color: #9ca3af;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
`;

const StyledSignUpButton = styled.div`
  background-color: #45b70c;
  color: white;
  border: none;
  border-radius: 500px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
`;

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: storage.getKey("logged"),
      show: this.props.show ? this.props.show : false,
      username: "",
      phone: "",
      email: "",
      password: "",
      confirmPassword: "",
      referral: this.props.referral || "",
      ruleChecked: false,
      ruleChecked18: false,
      submitted: false,
      disabled: false,
      effect: "zoomIn",
    };
  }

  componentDidMount() {
    socket.on(C.REGISTER_USER, (data) => this.setRegister(decode(data)));
    Event.on("register_form", () => {
      this.handleShow();
    });
  }

  setRegister = (data) => {
    console.log(data);
    if (data.error) {
      this.setState({ disabled: false, submitted: false });
      return sendNotfication(data.error, "success", "bottom-left");
    }

    if (data.status) {
      console.log("datataaaa", data);
      this.setState({ submitted: false });
      wait(1000).then(() => {
        socket.emit(
          C.LOGIN_USER,
          encode({
            username: data.name,
            password: data.password,
            recaptcha: "google",
          })
        );
      });
    }
  };

  handleShow = () => {
    this.setState({ show: true, effect: "zoomIn" });
  };

  handleClose = () => {
    this.setState({
      show: false,
      effect: "zoomOut",
      disabled: false,
      submitted: false,
      ruleChecked: false,
      ruleChecked18: false,
    });
  };

  verifyRefrelCode = async () => {
    try {
      const response = await axios.get(
        `https://api.betbazaar365.com/verify-referral-code/${this.state.referral}`
      );
      console.log("response comes like", response);

      return response?.data?.valid;
    } catch (error) {
      console.log("error", error);
    }
  };

  handleSubmit = async (e) => {
    var verified;
    e.preventDefault();
    this.setState({ submitted: true, disabled: true });

    const {
      username,
      email,
      phone,
      password,
      confirmPassword,
      ruleChecked,
      referral,
      ruleChecked18,
    } = this.state;

    if (!phone) {
      sendNotfication("Please enter a phone number", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (isNaN(phone)) {
      sendNotfication(
        "Please enter a valid phone number",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }

    if (phone.length < 10 || phone.length > 15) {
      sendNotfication(
        "Please enter a valid phone number",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }

    if (!username) {
      sendNotfication("Please enter a username", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }
    if (!password) {
      sendNotfication("Please enter a password", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }
    if (!confirmPassword) {
      sendNotfication(
        "Please enter a confirm password",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }
    if (password !== confirmPassword) {
      sendNotfication("Passwords do not match", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (!ruleChecked18) {
      sendNotfication(
        "You must be at least 18 years old to continue",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }
    if (!ruleChecked) {
      sendNotfication(
        "Please agree to the terms and conditions",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }

    if (username.length < 5) {
      this.setState({ disabled: false });
      sendNotfication(
        "Please enter username more than 5 words",
        "success",
        "bottom-left"
      );
      return;
    }

    if (referral && referral.trim() !== "") {
      console.log(referral);
      let verified = await this.verifyRefrelCode();
      if (!verified) {
        console.log("inside false");
        this.setState({ disabled: false });
        sendNotfication(
          "Please enter a valid referral code",
          "error",
          "bottom-left"
        );
        return;
      }
    }

    function randomEmail() {
      const domains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com"];
      const randomString = Math.random().toString(36).substring(2, 10);
      const randomDomain = domains[Math.floor(Math.random() * domains.length)];
      return `${randomString}@${randomDomain}`;
    }

    socket.emit(
      C.REGISTER_USER,
      encode({
        phone: phone,
        username: username,
        password: password,
        email: email || randomEmail(),
        method: true,
        refree: referral || "",
        aff: storage.getKey("aff") ? storage.getKey("aff") : null,
      })
    );
    this.handleClose();
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  checkRule = () => {
    this.setState((prevState) => ({ ruleChecked: !prevState.ruleChecked }));
  };
  checkRule18 = () => {
    this.setState((prevState) => ({ ruleChecked18: !prevState.ruleChecked18 }));
  };

  login = () => {
    this.handleClose();
    Event.emit("login_form");
  };

  render() {
    const {
      show,
      username,
      phone,
      email,
      password,
      confirmPassword,
      ruleChecked,
      disabled,
      referral,
      ruleChecked18,
    } = this.state;

    return (
      <>
        {storage.getKey("logged") ? (
          false
        ) : (
          <StyledSignUpButton
            onClick={this.handleShow}
            className="button-brand game-fonts"
          >
            Sign up
          </StyledSignUpButton>
        )}

        <StyledModal
          size="lg"
          centered={false}
          show={storage.getKey("logged") ? false : show}
          onHide={this.handleClose}
          aria-labelledby="register-modal"
          className={`register-modal animated ${this.state.effect}`}
        >
          <RegisterContainer className="register-container">
            <RegisterLeft className="register-left-panel">
              <RegisterTopImage
                className="register-hero-image"
                src="/assets/bcimages/login/signup.png"
                alt="Register Visual"
              />
              {/* <RegisterLogoImage
                className="register-brand-logo"
                src="/assets/bcimages/assamgames.png"
                alt="Brand Logo"
              /> */}
              <MobileCloseButton
                onClick={this.handleClose}
                className="mobile-close-btn"
              >
                ×
              </MobileCloseButton>
            </RegisterLeft>

            <RegisterRight className="register-right-panel">
              <ModalHeader className="register-header">
                <SignUpTitle className="register-title">Sign up</SignUpTitle>
                <CloseButton
                  onClick={this.handleClose}
                  className="desktop-close-btn"
                >
                  ×
                </CloseButton>
              </ModalHeader>

              <StyledForm
                onSubmit={this.handleSubmit}
                className="register-form"
              >
                <InputGroup className="phone-input-group">
                  <PhoneInputWrapper className="phone-input-wrapper">
                    <StyledPhoneInput
                      type="text"
                      name="phone"
                      value={phone}
                      onChange={this.handleInputChange}
                      placeholder="Phone Number"
                      className="phone-input"
                    />
                  </PhoneInputWrapper>
                </InputGroup>

                <InputGroup className="username-input-group">
                  <StyledInput
                    type="text"
                    name="username"
                    value={username}
                    onChange={this.handleInputChange}
                    placeholder="Username"
                    className="username-input"
                  />
                </InputGroup>

                <InputGroup className="email-input-group">
                  <StyledInput
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.handleInputChange}
                    placeholder="Email Address"
                    className="email-input"
                  />
                </InputGroup>

                <InputGroup className="password-input-group">
                  <StyledInput
                    type="password"
                    name="password"
                    value={password}
                    onChange={this.handleInputChange}
                    placeholder="Password"
                    className="password-input"
                  />
                </InputGroup>

                <InputGroup className="confirm-password-input-group">
                  <StyledInput
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={this.handleInputChange}
                    placeholder="Confirm password"
                    className="confirm-password-input"
                  />
                </InputGroup>

                <InputGroup className="referral-input-group">
                  <StyledInput
                    name="referral"
                    value={referral}
                    onChange={this.handleInputChange}
                    placeholder="Referral Code"
                    className="referral-input"
                  />
                </InputGroup>

                <CheckboxContainer className="age-checkbox-container">
                  <CheckboxInput
                    type="checkbox"
                    id="ageCheck"
                    checked={ruleChecked18}
                    onChange={this.checkRule18}
                  />
                  <CheckboxLabel htmlFor="ageCheck">
                    I agree & confirm I am at least 18 years old
                  </CheckboxLabel>
                </CheckboxContainer>

                <CheckboxContainer className="terms-checkbox-container">
                  <CheckboxInput
                    type="checkbox"
                    id="ruleCheck"
                    checked={ruleChecked}
                    onChange={this.checkRule}
                  />
                  <CheckboxLabel htmlFor="ruleCheck">
                    I agree with the user agreement
                  </CheckboxLabel>
                </CheckboxContainer>

                <ButtonContainer className="button-container">
                  <SignUpButton
                    type="submit"
                    disabled={disabled}
                    className="signup-submit-btn"
                  >
                    {disabled && (
                      <span
                        className="spinner-grow spinner-grow-sm mr-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {disabled ? "Signing up..." : "Sign Up"}
                  </SignUpButton>
                </ButtonContainer>

                <SignInSection className="signin-section">
                  Already have an account?
                  <SignInButton
                    onClick={this.login}
                    className="signin-trigger-btn"
                  >
                    Sign In
                  </SignInButton>
                </SignInSection>
              </StyledForm>
            </RegisterRight>
          </RegisterContainer>
        </StyledModal>
      </>
    );
  }
}

export default Register;
